import React from 'react';
import './aside.css';
import Navlink from './navlink';
import { ReactComponent as DashboardIcon } from '../assets/dashboard.svg';
import { ReactComponent as EventsIcon } from '../assets/events.svg';
import { ReactComponent as BookingsIcon } from '../assets/bookings.svg';
import { ReactComponent as CategoriesIcon } from '../assets/categories.svg';
import { ReactComponent as UsersIcon } from '../assets/users.svg';
import { ReactComponent as FeedbackIcon } from '../assets/feedback.svg';
import { ReactComponent as ContentManagementIcon } from '../assets/contentmanagment.svg';

const Aside = ({ isOpen, setIsOpen }) => {
  const links = [
    { text: 'Dashboard', to: '/', icon: DashboardIcon },
    { text: 'Events', to: '/events', icon: EventsIcon },
    { text: 'Bookings', to: '/bookings', icon: BookingsIcon },
    { text: 'Categories', to: '/categories', icon: CategoriesIcon },
    { text: 'Users', to: '/users', icon: UsersIcon },
    { text: 'Subscribers', to: '/subscribers', icon: UsersIcon },
    { text: 'Testimonials', to: '/testimonials', icon: FeedbackIcon },
    { text: 'Content Management',
      to: '/content-management',
      icon: ContentManagementIcon,
    },
  ];

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <h1 className="sidebar_brand">EVENTRA</h1>

      <nav className="sidebar_nav">
        <ul className="sidebar_menu">
          {links.map((link) => (
            <Navlink
              key={link.to}
              icon={link.icon}
              linktext={link.text}
              to={link.to}
            />
          ))}
        </ul>
      </nav>

      <div className="sidebar_footer">
        <div className="sidebar_footer_name">Admin User</div>
        <a className="sidebar_footer_email" href="mailto:admin@eventra.com">
          admin@eventra.com
        </a>
      </div>
    </aside>
    {isOpen && <div className="sidebar_overlay" onClick={() => setIsOpen(false)}></div>}
  </>
  );
};

export default Aside;
